import { Component, EventEmitter, Output } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

@Component({
  selector: 'app-home-seva-contemplation',
  templateUrl: './home-seva-contemplation.component.html',
  styleUrls: ['./home-seva-contemplation.component.scss']
})
export class HomeSevaContemplationComponent {

  @Output() formGroupChange = new EventEmitter<FormGroup>();
  @Output() nextStep = new EventEmitter<void>();
  @Output() previous = new EventEmitter<void>();

  siddhaYogaForm!: FormGroup;
  submitted = false;

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    this.siddhaYogaForm = this.fb.group({
      teachings: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(5000)]],
      appliedTeaching: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(5000)]],
      sevaQualities: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(5000)]],
      lifeSituation: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(5000)]],
    });

    this.formGroupChange.emit(this.siddhaYogaForm);
  }

  onSubmit() {
    this.submitted = true;
    if (this.siddhaYogaForm.valid) {
      this.nextStep.emit();
    }
  }

  goToBack() {
    this.previous.emit();
  }
}